import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomBeforeAfterSlider from '../components/CustomBeforeAfterSlider';
import './Page3.css';

import bg_curvas_2_PT from './../assets/page3/bg_curvas_02_pt.png';
import bg_curvas_1_PT from './../assets/page3/bg_curvas_01_pt.png';
import homeButtonImage from './../assets/commum/button_home.png';

function Page3_1(props) {
  const navigate = useNavigate();  

  return (
    <div className="page3-container">
      <CustomBeforeAfterSlider firstImage={bg_curvas_1_PT} secondImage={bg_curvas_2_PT} />
      <div className="back-button" style={{ bottom: '119px', left: '75px', width: '76px', height: '50px' }} onClick={() => navigate('/page3')}>
        <img src={homeButtonImage} alt="Home Button" />
      </div>
    </div>
  );
}

export default Page3_1;
